import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IHTTPResponse } from 'app/core-lib/interfaces/http-response';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class InterchainDashboardService {
  constructor(private http: HttpClient) {}

  getProductsStatus(customerIds: string) {
    const url = `${environment.customerPath}customers/products`;
    const params: HttpParams = new HttpParams().set('customers_ids', customerIds);
    return this.http.get(url, { params: params }).pipe(map((response) => response));
  }

  getRankingTableData(
    customerIds: string,
    dates: { startDate: string; endDate: string },
    sortBy = 'negative_count',
    topN = 10,
    products?: number[],
  ): Observable<IHTTPResponse> {
    const url = `${environment.sentimentPath}corporative/summary/rankings/pairs`;
    let params: HttpParams = new HttpParams()
      .set('customers_ids', customerIds)
      .set('start_date', dates.startDate)
      .set('end_date', dates.endDate)
      .set('sort_by', sortBy)
      .set('top_n', topN);
    if (products?.length) {
      params = params.set('product_ids', products.join(','));
    }
    return this.http.get<IHTTPResponse>(url, { params: params });
  }

  getRecommendations(customerIds: string, languageId: number): Observable<IHTTPResponse> {
    const url = `${environment.sentimentPath}smart-reports/recommendations`;
    const params: HttpParams = new HttpParams().set('customers_ids', customerIds).set('language_id', languageId);
    return this.http.get<IHTTPResponse>(url, { params: params });
  }

  getSmartReportData(smartReportId: number, languageId: number): Observable<IHTTPResponse> {
    const url = `${environment.sentimentPath}smart-reports/${smartReportId}/language/${languageId}`;
    return this.http.get<IHTTPResponse>(url);
  }
}
